import React from "react";
import Icon from "./Icon";
export default function Speaker(props) {
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 1.83333H5.50008C4.48756 1.83333 3.66675 2.65414 3.66675 3.66666V18.3333C3.66675 19.3458 4.48756 20.1667 5.50008 20.1667H16.5001C17.5126 20.1667 18.3334 19.3458 18.3334 18.3333V3.66666C18.3334 2.65414 17.5126 1.83333 16.5001 1.83333Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9999 16.5C13.025 16.5 14.6666 14.8584 14.6666 12.8333C14.6666 10.8083 13.025 9.16667 10.9999 9.16667C8.97487 9.16667 7.33325 10.8083 7.33325 12.8333C7.33325 14.8584 8.97487 16.5 10.9999 16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 5.5H11.01"
  }));
}
Speaker.displayname = "Speaker";
//# sourceMappingURL=Speaker.js.map